export class ValidationOutput {
    constructor(code, severity, message, path, schemaPath, line_start, line_end, character_start, character_end, source) {
        this.code = code;
        this.severity = severity;
        this.message = message;
        this.path = path;
        this.schemaPath = schemaPath;
        this.line_start = line_start;
        this.line_end = line_end;
        this.character_start = character_start;
        this.character_end = character_end;
        this.source = source;
    }
    /**
     * Build an `error`-severity output without the positional `line`/`character` noise.
     * @param opts.schemaPath optional JSON-schema path.
     * @param opts.source     optional source label (e.g. 'architecture' or 'pattern').
     */
    static error(code, message, path, opts = {}) {
        return new ValidationOutput(code, 'error', message, path, opts.schemaPath, undefined, undefined, undefined, undefined, opts.source);
    }
    /**
     * Build a `warning`-severity output without the positional `line`/`character` noise.
     * @param opts.schemaPath optional JSON-schema path.
     * @param opts.source     optional source label (e.g. 'architecture' or 'pattern').
     */
    static warning(code, message, path, opts = {}) {
        return new ValidationOutput(code, 'warning', message, path, opts.schemaPath, undefined, undefined, undefined, undefined, opts.source);
    }
}
export class ValidationOutcome {
    constructor(jsonSchemaValidationOutputs, spectralSchemaValidationOutputs, hasErrors, hasWarnings) {
        this.jsonSchemaValidationOutputs = jsonSchemaValidationOutputs;
        this.spectralSchemaValidationOutputs = spectralSchemaValidationOutputs;
        this.hasErrors = hasErrors;
        this.hasWarnings = hasWarnings;
    }
    //Gaze into the Javascript abyss. Type safety cannot save you here.
    allValidationOutputs() {
        return [...(this.jsonSchemaValidationOutputs || []), ...(this.spectralSchemaValidationOutputs || [])];
    }
}
//# sourceMappingURL=validation.output.js.map